import ProfileHeader from "./profileHeader.container";

export default ProfileHeader;